import { useEffect } from "react"
import { Navigation } from "@/components/public/layout/Navigation"
import { Footer } from "@/components/public/layout/Footer"
import FloatingMenu from "@/components/public/FloatingMenu"

export default function PocketBookPage() {
    useEffect(() => {
        window.location.href = "https://go.undiksha.ac.id/BUKU_SAKU_KONASPIXII";
    }, []);

    return (
        <div className="min-h-screen flex flex-col bg-background dark:bg-gray-900">
            <Navigation />
            <div className="flex-grow flex items-center justify-center">
                <p className="text-lg text-gray-600 dark:text-gray-300">Mengarahkan ke Buku Saku...</p>
            </div>
            <Footer />
            <FloatingMenu />
        </div>
    )
}
